export function delayAsync(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
//# sourceMappingURL=delay-async.js.map